module.exports = __webpack_public_path__ + "static/29-880d367ded4522bcf455481924d4724a.jpg";